export const retornaApenasNumero = (string: string): string => {
  if (string === null) {
    string = "";
  }
  return string.replace(/[^0-9]/g, "");
};
